

































































import Vue from 'vue';
import ItemsProvider from '@/api/ItemsProvider';
import IItemStub from '@/models/items/IItemStub';
import DvSkeleton from '@/components/util/DvSkeleton.vue';
import ItemIcon from '@/old/game/ItemIcon.vue';
import Item from '@/old/api/item/item';
import ItemStat from '@/old/api/item/itemstat';

Vue.component('item-icon', ItemIcon);

export default Vue.extend({
    name: 'DvItemCard',
    components: { DvSkeleton },
    props: {
        itemId: { type: Number },
        itemStub: { type: Object as () => IItemStub | null, default: null },
        count: { type: Number, default: 0 },
        rate: { type: Number, default: 0 },
        goldAmt: { type: Number, default: 0 },
        potentialNum: { type: Number, default: 0 },
        noLink: { type: Boolean, default: false },
        onClick: { type: Function, default: null },
        timeLimit: { type: Number, default: 0 },
        variant: { type: String as () => 'card' | 'row', default: 'card' },
    },
    data() {
        return {
            data: null as IItemStub | null,
            loading: true,
            valid: true,
            error: false,
            stackSize: 0,
        };
    },
    created() { this.fetchData(); },
    watch: {
        itemId() { this.fetchData(); },
        count(to: number) { this.stackSize = to; },
    },
    computed: {
        techMode(): boolean { return this.$store.state.techMode; },
        rankClass(): string { return (this.data?.rank ?? '').toString().toLowerCase(); },
        //  `rate` and `thousands` are GLOBAL filters, applied in the template
        //  with `|`. Do not reach for them via this.$options.filters here: it
        //  resolves only through the prototype chain and types as any.
        showIdOnRight(): boolean {
            return this.techMode && !this.rate && !this.goldAmt;
        },
        //  Tech id is displaced into the chip row when the edge is taken, so the
        //  right edge never stacks two pills.
        showIdInChips(): boolean {
            return this.techMode && (!!this.rate || !!this.goldAmt);
        },
        durationDays(): number {
            return this.timeLimit || this.data?.durationDays || 0;
        },
        name(): string {
            const n = this.data?.name;
            if (n?.name && n._NameID) return n.name;
            if (n?._NameID) return `Item MID: ${n._NameID}`;
            return `Unnamed Item ${this.itemId}`;
        },
        skillName(): string {
            const s = this.data?.skillInfo;
            return s?.name?.message ?? s?.displayName ?? `Skill ${s?.id}`;
        },
        classNames(): string {
            const c = this.data?.needClass;
            if (!c) return '';
            return c.filter((x) => x.id !== 0).map((x) => x.displayName).join('/\u200B');
        },
        category(): string { return Item.getItemDetailedCategory(this.data); },
        itemQuery(): Record<string, number> {
            return this.potentialNum ? { potential: this.potentialNum } : {};
        },
        itemEasyUrl(): string { return Item.itemEasyUrl(this.itemId, this.data ?? this.itemStub); },
        potentialStatList(): Array<{ abbv: string }> {
            //  Unchanged from the old card: first three distinct stats of the
            //  selected potential roll, min/max pairs folded to one entry.
            const potentials: any = (this.data as any)?.potentials;
            if (!potentials || !this.potentialNum) return [];
            for (const k of Object.keys(potentials)) {
                const v = potentials[k];
                if (v.potentialNumber !== this.potentialNum) continue;
                const seen: Record<string, unknown> = {};
                const out: Array<{ abbv: string }> = [];
                for (const s of v.states) {
                    let key = s.state;
                    let info = ItemStat.getStateInfo(key);
                    if (info.minmax) { key = info.minmax; info = ItemStat.getStateInfo(key); }
                    if (!seen[key]) { seen[key] = info; out.push(info); }
                }
                return out.slice(0, Math.min(3, out.length));
            }
            return [];
        },
    },
    methods: {
        async fetchData() {
            this.loading = true;
            this.data = null;
            this.error = false;
            this.valid = true;
            this.stackSize = this.count;

            if (this.itemStub) {
                if (!this.itemStub.type) { this.valid = false; return; }
                this.data = this.itemStub;
                this.loading = false;
                return;
            }
            try {
                const s = await ItemsProvider.getStub(this.itemId);
                if (!s) { this.error = true; } else { this.data = s; }
            } catch {
                this.error = true;
            } finally {
                this.loading = false;
            }
        },
    },
});
